import { httpClient, handleError, httpClient1 } from '.';
export const _baseModelList = params => {
  console.log(params);
  return httpClient
    .post(
      'base_model/list',
      {
        canteen_id: params.canteen_id
      },
      {
        headers: {
          'api-key': params.api_key
        }
      }
    )
    .then(res => {
      return res.data;
    })
    .catch(handleError);
};
export const _getDetailByModelId = modelUuid => {
  return httpClient
    .post('base_model/dish/info', {
      model_uuid: modelUuid
    })
    .then(res => res.data)
    .catch(handleError);
};
// 批量添加大图
export const _batchAddImages = ({ canteenId, imgList, apiKey }) => {
  console.log(canteenId, imgList, apiKey);
  return httpClient
    .post(
      'data_batch/collect',
      {
        canteen_id: canteenId,
        img_list: imgList
      },
      {
        headers: {
          'api-key': apiKey
        }
      }
    )
    .then(res => res.data)
    .catch(handleError);
};
export const _register = params => {
  return httpClient1
    .post('register/', params)
    .then(res => res.data)
    .catch(handleError);
};

export const _getImageByUUID = uuid => {
  return httpClient
    .post('base_model/dish/info', {
      model_uuid: uuid
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.erro_msg}`));
      }
    })
    .catch(handleError);
};
export const _getMarkDataCount = ({dishUUIDList, date_range, canteen_id, label_task_uuid_list, ex_dish_uuid_list}) => {
  return httpClient
    .post('train_task/img_count', {
      dish_uuid_list: dishUUIDList,
      label_task_uuid_list,
      date_range,
      canteen_id,
      ex_dish_uuid_list
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.erro_msg}`));
      }
    })
    .catch(handleError);
};
export const _stopTask = ({ task_uuid, api_key }) => {
  return httpClient
    .post(
      'train_task/stop',
      { task_uuid },
      {
        headers: {
          'api-key': api_key
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    })
    .catch(handleError);
};
export const _getTask = ({ api_key, canteen_id }) => {
  return httpClient
    .post(
      'train_task/list',
      {
        canteen_id
      },
      {
        headers: {
          'api-key': api_key
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else if (res.data.state_code === -1) {
        return Promise.resolve({ task_list: [] });
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
/**
 * 新建任务
 * @param collect_time_range
 * @param canteen_id
 * @param base_model_uuid
 * @param api_key
 * @param class_id_list
 * @param task_desc
 * @returns {Promise$1|PromiseObj|Promise$1|PromiseObj|PromiseLike<T | never>|Promise<T | never>|*}
 * @private
 */
export const _newTask = ({
  label_task_uuid_list,
  collect_time_range,
  canteen_id,
  base_model_uuid,
  api_key,
  class_id_list,
  task_desc,
  ex_dish_uuid_list
}) => {
  return httpClient
    .post(
      'train_task/new',
      {
        label_task_uuid_list,
        collect_time_range,
        canteen_id,
        base_model_uuid,
        class_id_list,
        task_desc,
        ex_dish_uuid_list
      },
      {
        headers: {
          'api-key': api_key
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(true);
      } else if (res.data.state_code === 1 || res.data.state_code === 2) {
        return Promise.resolve(false);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getTrainedModelList = ({ api_key, canteen_id }) => {
  return httpClient
    .post(
      'base_model/list',
      { canteen_id },
      {
        headers: {
          'api-key': api_key
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _selectTrainAcc = accKey => {
  return httpClient
    .post('train_task/acc/choice', {
      acc: accKey
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(true);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getTrainedImages = ({ class_id, apiKey }) => {
  return httpClient
    .post(
      'dish_train_img/query',
      { class_id },
      {
        headers: {
          'api-key': apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    })
    .catch(handleError);
};
export const _getbackDataByCanteen = canteen_id => {
  return httpClient
    .post('back_data/query_by_canteen', {
      canteen_id
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getCollectInference = params => {
  return httpClient
    .post('data_batch/collect_inference', { ...params })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _cancelCheck = label_task_uuid => {
  console.log(label_task_uuid);
  return httpClient
    .post('label_task/cancel_check', { label_task_uuid })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
/**
 * 获取任务历史
 * @param dateRange
 * @returns {Promise<T | never>}
 * @private
 */
export const _getTaskHistory = date_range => {
  return httpClient
    .post('label_task/history/query', {
      date_range
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
/**
 * 获取历史任务的详细信息, 用作回看或者重新标注
 * @param label_task_uuid
 * @returns {Promise$1|PromiseObj|Promise$1|PromiseObj|PromiseLike<T | never>|Promise<T | never>|*}
 * @private
 */
export const _getCheckedImgByTaskId = label_task_uuid => {
  return httpClient
    .post('label_task/history_info', {
      label_task_uuid
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};

export const _getImgByUuid = img_uuid => {
  return httpClient.post('get_img/by_uuid', { img_uuid }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _getImgByUuidList = img_uuid_list => {
  return httpClient.post('get_img/by_uuid_list', { img_uuid_list }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _getTrainTaskList = apiKey => {
  return httpClient
    .get('training_task/list', {
      headers: {
        'api-key': apiKey
      }
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _setTaskUrgent = (label_task_uuid_list, urgent) => {
  console.log(label_task_uuid_list);
  return httpClient
    .post('label_task/urgent', { label_task_uuid_list, urgent })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    })
    .catch(e => {
      return Promise.reject(e);
    });
};
export const _historyTaskRemark = ({
  apiKey,
  label_info_list,
  label_task_uuid,
  train_check_state,
  trainable,
  username
}) => {
  return httpClient
    .post(
      'label_task/history_mark',
      {
        label_info_list,
        label_task_uuid,
        train_check_state,
        trainable,
        username
      },
      {
        headers: {
          'api-key': apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    })
    .catch(handleError);
};
export const _getServerPointList = () => {
  return httpClient.get('server_point/info').then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _getTaskListBeforeNewTask = dish_uuid_list => {
  return httpClient
    .post('train_task/label_task_list', { dish_uuid_list })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _setTaskTrainable = ({ label_task_uuid_list, trainable }) => {
  return httpClient
    .post('label_task/trainable_set', {
      label_task_uuid_list,
      trainable
    })
    .then(res => {
      console.log(res);
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
